// pasteHandler.js
import { EventBus } from './event_bus'

// Function to check if the current URL matches the allowed pattern
function isAllowedUrl() {
  const allowedUrlPatterns = [
    /^\/nlu\/model\/[^/]+\/entity$/
    // other patterns
  ]

  return allowedUrlPatterns.some(pattern =>
    pattern.test(window.location.pathname)
  )
}

document.addEventListener('paste', event => {
  const target = event.target

  if (!isAllowedUrl()) {
    return
  }

  // Check if the target is an input or textarea and allow the normal paste behavior
  if (
    target.tagName === 'INPUT' ||
    target.tagName === 'TEXTAREA' ||
    target.isContentEditable
  ) {
    return
  }

  event.preventDefault()
  const clipboardData = event.clipboardData || window.clipboardData
  const pastedData = clipboardData.getData('Text')

  // Parse the pasted data
  try {
    const parsedData = JSON.parse(pastedData)

    // Check the format and determine which event to emit
    if (parsedData.reference && parsedData.synonyms && parsedData.id) {
      const cleanedData = _.pick(parsedData, ['reference', 'synonyms'])
      EventBus.$emit('open-dialog', cleanedData, 'handle-entity-data')
      return
    }

    const validEntities = parsedData.filter(d => {
      return d.name && d.type && (Array.isArray(d.data) || d.extract_rule)
    })

    if (validEntities.length > 0) {
      const cleanedData = parsedData.map(item => {
        if (item.type !== 'regular_expression') {
          item.data = item.data.map(d => {
            return _.pick(d, ['reference', 'synonyms'])
          })
        }
        return item
      })

      EventBus.$emit('open-dialog', cleanedData, 'handle-entity')
      return
    }
  } catch (error) {
    // Do nothing
    return
  }
})
